const getFullYear = () => new Date().getFullYear()

export default getFullYear
